// Lead-only analytics. We track exactly one event: GA4 `generate_lead` on
// successful funnel submission. No CTA-click noise.

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
    gtag?: (...args: unknown[]) => void;
  }
}

export const trackGenerateLead = (params: {
  service_type: string;
  timing: string;
  photo_count: number;
}) => {
  if (typeof window === "undefined") return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "generate_lead",
    ...params,
  });
  window.gtag?.("event", "generate_lead", params);

  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.log("[generate_lead]", params);
  }
};
